module.exports = __webpack_public_path__ + "static/img/logo.8cc956d.png";